'use client';

import { PortalLink } from '@akademi/site-builder-runtime';
import { useSolarText } from '../locales/useSolarText';

const STEPS = ['CartView', 'CheckoutForm', 'OrderConfirmation'];
const LABELS = ['purchase.basket', 'purchase.checkout', 'purchase.confirmation'];

/**
 * Progress describes the current page; it never bypasses order placement.
 *
 * <p>Presentation follows the Horizon mockups' `.steps` register
 * (redesign-2026-10-01, css/shared.css): leading-zero mono numbers in pill
 * rings, a filled ring on the current step, and `is-done` marking completed
 * steps for the stylesheet. The 3-step structure and the one allowed link —
 * back to the basket from checkout, never ahead — are unchanged.
 */
export function PurchaseSteps({ type, cartHref = '/cart' }: { type: string; cartHref?: string }) {
  const t = useSolarText();
  const current = STEPS.indexOf(type);
  if (current < 0) return null;
  return <nav className="ae-purchase" aria-label={t('purchase.label')}>
    <ol>{STEPS.map((step, index) => <li key={step} className={index < current ? 'is-done' : undefined} aria-current={index === current ? 'step' : undefined}>
      <span className="ae-purchase__number" aria-hidden="true">{String(index + 1).padStart(2, '0')}</span>
      {current === 1 && index === 0 ? <PortalLink href={cartHref}>{t(LABELS[index]!)}</PortalLink> : <span>{t(LABELS[index]!)}</span>}
    </li>)}</ol>
  </nav>;
}
